
export {simpleFilter,
test,
match,
filter} from '../../../frontend-js-dependencies-web/__liferay__/exports/fuzzy.js';
import __x__ from '../../../frontend-js-dependencies-web/__liferay__/exports/fuzzy.js';export default __x__;